module.exports = __webpack_public_path__ + "static/media/butt06.fe9abb86.png";